var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"goldenP"},[_c('img',{staticStyle:{"width":"20px","margin-right":"10px","margin-left":"10px"},attrs:{"src":require("@/assets/leadercup.svg")}}),_vm._v(_vm._s(_vm.$t("LanguageEn.leaderboard"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }